import { render } from "./BlogDetalle.vue?vue&type=template&id=245d8ded"
import script from "./BlogDetalle.vue?vue&type=script&lang=js"
export * from "./BlogDetalle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__